module.exports = __webpack_public_path__ + "img/ibkr.35a15254.png";